<template>
    <div class="preUser expand">
        <modalRecoverPassword ref="modalRecoverStudent"/>
        <div class="preUser-left">
            <div class="content-login">
                <b-link  to="/" style="width: fit-content;">
                    <img class="logo" src="@/assets/img/logo-login.png">
                </b-link>   
                <b-form class="Login">
                    <div class="body">
                        <header>
                            <p>Plataforma de Estudiantes</p>
                            <h6 class="sub-title"><span>Iniciar sesión</span></h6>
                        </header>
                        <b-form-group label="Correo electrónico">
                            <!-- <p>Correo electrónico</p> -->
                            <b-form-input v-model.trim="user.email"   required  @keyup.enter="procesarLogin"
                                v-bind:class="{ error: $v.user.email.$error}" @keyup="$v.user.email.$touch()" autocomplete="off"
                            >
                            </b-form-input>
                            <span class="error-input">{{ validationMsgLogin($v.user.email)}}</span>
                        </b-form-group>

                        <b-form-group label="Contraseña">
                            <!-- <p>Contraseña</p> -->
                            <b-icon class="eye" :icon="eyesPassword ? 'eye':'eye-slash'" aria-hidden="true" @click="eyesPassword=!eyesPassword"></b-icon>
                            <b-form-input :type="eyesPassword ? 'password':'text'" v-model.trim="user.password" :placeholder=" eyesPassword ? '*********':'Ingrese la contraseña'" required autocomplete="off"
                                v-bind:class="{ error: $v.user.password.$error}" @keyup="$v.user.password.$touch()"  @keyup.enter="procesarLogin"
                            ></b-form-input>
                            <span class="error-input">{{ validationMsgLogin($v.user.password)}}</span>
                        </b-form-group>
                        <b-button variant="primary" class="mb-2 mt-1"  @click="procesarLogin" :class="{ loading: isLoading }" style="font-family: 'Gotham_Rounded_Book';">
                            <icon name="login" />Iniciar sesión
                        </b-button>
                        <div class="mt-1">
                            <b-link class="link blue"  @click="getModalRecover"><span>¿Olvidaste tu contraseña?</span></b-link>
                        </div> 
                    </div>
                        <p class="mb-0">¿No eres miembro? <span><a href="/student/register" class="link blue mt-3"><span>Regístrate</span></a></span></p>
                </b-form>
            </div>
        </div>
        <div class="preUser-right">
            <img src="@/assets/img/login-background2.jpg" class="no_mb"/>
            <p>Propiedad de English Advance SAC, 2021.<br class="no_desktop"/>  Todos los Derechos Reservados.</p>
        </div>
        <b-toast
            id="toast-login-error"
            variant="none"
            no-close-button
            toaster="b-toaster-top-center" 
            >
            <img
                src="@/assets/img/ico-equis.png"
                style="margin-right: 10px; margin-top: -2px"
            />
            {{ messageLogin }}
		</b-toast>
    </div>
 
</template>
<script>
import { PERFILES} from '@/assets/js/appConstants'; 
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import { required, email } from 'vuelidate/lib/validators';
import { validationMessage } from 'vuelidate-messages';
import modalRecoverPassword from "@/components/modals/ModalRecoverPassword.vue";
const formMessagesLogin = {
    requiredEmail: function () {
        return "Por favor ingresa tu correo electrónico."
    },
    requiredPassword: function () {
        return "Por favor ingresa tu contraseña."
    },
    email: function () {
        return "Debe ser un correo electrónico válido."
    }
}

export default {
    data:function(){
        return{
            API_URL: process.env.VUE_APP_API_URL,
            user:{
                email:'',
                password:'',
                personsTypeId:PERFILES.ALUMNO
            },
            messageLogin:'',
            isLoading: false,
            eyesPassword: true,
            isResponsive: false
 
        }
    },
    components:{
        modalRecoverPassword
    },
    computed: {
        UserId: {
            get() {
                return this.$store.state.user_id;
            },
            set(value) {
                this.$store.commit('mutateUserId', value);
            }
        },
        User: {
            get() {
                return this.$store.state.user;
            },
            set(value) {
                this.$store.commit('mutateUser', value);
            }
        },
        
    },
    validations: {
        user:{
            // email: {
            //     required,
            //     email: 'validaciones.formMessagesLogin.email'
            // },
            email: {
                 requiredEmail:required,
                email
            },
            password: {
                 requiredPassword:required
            }    
        }
            
    },
    created(){
        if(localStorage.getItem('lang') == null){
			localStorage.setItem('lang', "es");
			this.$i18n.locale = "es";
		}
    },
    mounted(){
        window.innerWidth > 576 ? this.isResponsive=true : this.isResponsive=false
    },
    methods: {
        getModalRecover(){
            this.$refs.modalRecoverStudent.getShowModal(PERFILES.ALUMNO)
        },
        validationMsgLogin: validationMessage(formMessagesLogin),
        procesarLogin: function() {
            if (!this.isLoading) {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                this.logIn();
            }
        },
        logIn: function() {
			this.isLoading = true;
            //this.user.FCM_Token = "";
			baseInstanceAxios
				.post(this.API_URL + `/resources/Persons/ValidateLogin`, this.user)
				.then(response => {
               
					if (response.data != null) {
						if(response.data.entity != null){//LOGUEADO CON EXITO
                            //console.log("response.data.entity  :",response.data.entity)
                            this.UserId = response.data.entity.id;
                            this.User = {
                                    "id": response.data.entity.id,
                                    "firstName": response.data.entity.firstName,
                                    "lastName": response.data.entity.lastName,
                                    "strFullName": response.data.entity.strFullName,
                                    "email": response.data.entity.email,
                                    "birthDate": response.data.entity.birthDate,
                                    "age": parseInt(response.data.entity.strAge,10),
                                    "photo": response.data.entity.photo,
                                    "personsTypeId":PERFILES.ALUMNO,
                                    "personStudentId": response.data.entity.personStudentId,
                                    "timeZoneName" : response.data.entity.timeZoneName ? response.data.entity.timeZoneName: 'America/Lima',
                                    "timeZone" : response.data.entity.timeZone ? response.data.entity.timeZone.value.totalMinutes: 0,
                                    "isResponseReceived": response.data.entity.isResponseReceived,
                            };
                            this.$store.commit("mutateAuthToken", response.data.entity.userToken);
                            this.$store.commit("mutateIsTeacher", false);
                            this.$store.commit("mutateDatosSidebar", {});
                            this.$store.dispatch("updateFlagPostulant",response.data.entity.flagPostulant)
                            this.$store.dispatch("updateFlagValidateCalifications",response.data.entity.flagValidateCalifications)
                            
                            let language = localStorage.getItem("lang") || "es";
                            this.$i18n.locale = language;

                            if(response.data.entity.flagPurchaseHistory){
                                this.$router.push({ name: `dashboard` }).catch(err => {}); 
                            }else{
                                this.$router.replace({path:"/compra/0"}).catch(err => {});
                            }
                           
						}else{
                            this.messageLogin = response.data.message;
                            this.$bvToast.show("toast-login-error");
                        }
                        this.isLoading = false;
					}
				})
                .catch(error => {
                    //debugger;
                    console.log(error);
                    this.message = this.$t('my-cours.mesage-system-error');
                    this.$bvToast.show("toast-login-error");
                    this.isLoading = false;
                });
                
		},
    },
};
</script>